import {
  getVehicleFiltersCategories,
  getVehicleFiltersCountries,
  getVehicleFiltersServices,
} from '@api/vehicles';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const useVehicleFilters = () => {
  const { t } = useTranslation();
  const {
    data: services,
    isLoading: isServicesLoading,
    refetch: refetchServices,
  } = useQuery({
    queryKey: ['vehicle-table-filters-services'],
    queryFn: getVehicleFiltersServices,
  });

  const {
    data: countryCodes,
    isLoading: isCountryCodesLoading,
    refetch: refetchCountryCodes,
  } = useQuery({
    queryKey: ['vehicle-table-filters-countries'],
    queryFn: getVehicleFiltersCountries,
  });

  const {
    data: categories,
    isLoading: isCategoriesLoading,
    refetch: refetchCategories,
  } = useQuery({
    queryKey: ['vehicle-table-filters-categories'],
    queryFn: getVehicleFiltersCategories,
  });

  const refetchFilters = () => {
    refetchServices();
    refetchCountryCodes();
    refetchCategories();
  };

  return {
    filtersOptions: {
      services: services?.map((value) => ({ label: t(`SERVICE_TYPE.${value}`), value })) || [],
      countryCodes: countryCodes?.map((value) => ({ label: value, value })) || [],
      categories:
        categories?.map((value) => ({ label: t(`VEHICLE_CATEGORY.${value}`), value })) || [],
    },
    isLoading: isServicesLoading || isCountryCodesLoading || isCategoriesLoading,
    refetchFilters,
  };
};
